import { RenderableStory } from '../../types/story-reading.types.ts';

export const STORY_READING_SLICE_NAME = 'storyReading';

export enum KeyWordType {
  STEP_FIRST_WORD = 'STEP_FIRST_WORD',
  STEP_LAST_WORD = 'STEP_LAST_WORD',
  STEP_BEFORE_TRANSITION_WORD = 'STEP_BEFORE_TRANSITION_WORD',
  STEP_AFTER_TRANSITION_WORD = 'STEP_AFTER_TRANSITION_WORD',
}

export interface KeyWordPosition {
  startX: number;
  endX: number;
  line: number;
  indexInLine: number;
}

export interface StoryWordIndex {
  index: number;
  subindex: number;
}

export type KeyWordPositions = Partial<Record<KeyWordType, KeyWordPosition>>;
export type KeyWordIndices = Partial<Record<KeyWordType, StoryWordIndex>>;

export interface StoryReadingSliceState {
  currentStory?: RenderableStory;
  currentLine?: number;
  keyWordPositions: KeyWordPositions;
  keyWordIndices: KeyWordIndices;
}

export interface KeyWordPositionUpdatePayload {
  type: KeyWordType;
  position: KeyWordPosition;
}
